import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./lib/auth";
import { api } from "./lib/api";
import Login from "./pages/Login";
import DashboardLayout from "./layouts/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory";
import BulkEntry from "./pages/BulkEntry";
import BulkExit from "./pages/BulkExit";
import Movements from "./pages/Movements";
import Shelves from "./pages/Shelves";
import Transfer from "./pages/Transfer";
import DeletionRequests from "./pages/DeletionRequests";
import Brands from "./pages/Brands";
import Users from "./pages/Users";
import ExcelTransfer from "./pages/ExcelTransfer";
import Warehouse3D from "./pages/Warehouse3D";
import MachineParts from "./pages/MachineParts";
import Tasks from "./pages/Tasks";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="ticker text-[color:var(--text-3)]">Yükleniyor…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  return children;
}

export default function App() {
  // Keep-alive ping: hits the lightweight /api/health endpoint every 45s so
  // the K8s ingress + backend pod stay warm. Without this the user hits the
  // "wake up server" cold-start delay repeatedly during a long editing session.
  React.useEffect(() => {
    const ping = () => {
      api.get("/health").catch(() => {});
    };
    ping();
    const id = setInterval(ping, 45000);
    return () => clearInterval(id);
  }, []);

  return (
    <Routes>
      <Route path="/giris" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <DashboardLayout />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="stok" element={<Inventory />} />
        <Route path="toplu-giris" element={<BulkEntry />} />
        <Route path="toplu-cikis" element={<BulkExit />} />
        <Route path="hareketler" element={<Movements />} />
        <Route path="sehpalar" element={<Shelves />} />
        <Route path="transfer" element={<Transfer />} />
        <Route path="silme-talepleri" element={<DeletionRequests />} />
        <Route path="excel-aktarim" element={<ExcelTransfer />} />
        <Route path="depo-3d" element={<Warehouse3D />} />
        <Route path="makina-parcalari" element={<MachineParts />} />
        <Route path="firmalar" element={<Brands />} />
        <Route path="kullanicilar" element={<Users />} />
        <Route path="gorevler" element={<Tasks />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
